import { Base } from "./Base";
import { User } from "./User";
import { Request } from "./Request";
import { IComment } from "./shared/types";

import { createDate } from "@/common/utils";
import { transformDateRecent } from "@/common/filters";

export class Comment extends Base implements IComment {
  HalloId: string;
  Commentor: User;
  Date: Date;
  Text: string;

  Request: Request;

  protected _propertyNames = [
    'Commentor', 'Text', 'Date'
  ];

  constructor(comment?:IComment) {
    super();
    if (comment) {
      this.Properties = comment;
    }
  }

  get Properties() : IComment {
    return <IComment>this.getProperties();
  }

  set Properties(comment: IComment) {
    for (let p in comment) {
      if (p=='Commentor') {
        this[p] = new User();
        this[p].Properties = comment[p];
      } else if (this._propertyNames.indexOf(p) != -1) {
        this[p] = comment[p];
      }
    }
  }

  set PropertiesFromStorage(comment:any) {
    if (comment.id && comment.id!=this.HalloId) {
      this.HalloId = comment.id;
    }
    let p;
    let mapping;
    if (comment.commentor) {
      this.Commentor = this.Commentor || new User();
      this.Commentor.PropertiesFromStorage = comment.commentor;
    }
    if (comment.create_ts) {
      this.Date = createDate(comment.create_ts);
    }
    if (comment.text && comment.text!=this.Text) {
      this.Text = comment.text;
    }
  }

  get Index() : number {
    return this.Request.Comments.indexOf(this);
  }

  get DateRecent() : string {
    return transformDateRecent(this.Date, 'recent,yy-MMM');
  }
}
